var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26602 2.24782L5.67715 4.19612C5.73532 4.24271 5.74525 4.32821 5.69985 4.38778L2.84139 8.11241C2.6617 8.3425 2.3969 8.47267 2.11318 8.47747L0.552733 8.4967C0.46951 8.49765 0.396689 8.44001 0.377774 8.35739L0.0231265 6.81546C-0.0383457 6.53206 0.0231265 6.23905 0.202815 6.01328L3.07546 2.27088C3.1218 2.21083 3.20739 2.20026 3.26602 2.24782Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.75817 3.03501L6.29334 3.61527C6.24653 3.67435 6.16236 3.68396 6.1042 3.63689C5.53913 3.17959 4.09216 2.0061 3.6907 1.6809C3.63207 1.63287 3.62403 1.54737 3.67132 1.4878L4.11959 0.931077C4.52625 0.407496 5.23555 0.359461 5.80771 0.815793L6.46499 1.33937C6.73453 1.55073 6.91421 1.82933 6.97569 2.12234C7.04662 2.44466 6.97096 2.76121 6.75817 3.03501Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.27b0ccfbbcd227d873b0b22d6f9c15fa.svg";
export { ForwardRef as ReactComponent };